module.exports = "<app-products></app-products>\r\n"